<template>
  <section v-if="listPages.length > 0">
    <div 
      v-for="(page, index) in listPages" 
      :key="page.id" 
      @mouseenter="hoverStyle = page.id"
      @mouseleave="hoverStyle = null"
    >
      <div 
        :class="['pages-item', {'isPageMenuOpened': page.id === selectedPage}]" 
        @click="handleSelectPage(page, index)"
      >
        <div :class="['pages-item-icon']">
          <v-icon v-if="page.route === '/'" size="15" color="blackIcon">fa-regular fa-house</v-icon>
          <v-icon v-else size="15" color="blackIcon">fa-regular fa-page</v-icon>
        </div>

        <span>{{page.name}}</span>

        <!-- Pop Menu  -->
        <div class="active-page-menu">
          <transition>
            <PopUpMenu
              :visible="showMenuFromPage.id === page.id || page.id === hoverStyle"
              :options="getMenuOptions(page, index)"
              @click="onClickMenuOption(page.id, index)"
              @clickOutside="() => { showMenuFromPage.id = null }"
            >
            <div :class="['active-page-options', {'isPageMenuOpened': selectedPage === page.id}]">
              <v-icon size="12">fa-regular fa-ellipsis</v-icon>
            </div>
            </PopUpMenu>  
          </transition>              
        </div>
        <!-- End Pop Menu  -->
      </div>

      <div 
        v-if="page.id === selectedPage && page.route !== '/'" 
        class="pages-item pl-5" 
        style="cursor: default !important; background-color: white !important; font-size: 0.85rem"
      >
        <div class="pages-item-icon">
          <v-icon size="13" color="blackIcon">fa-regular fa-link-simple</v-icon>
        </div>

        <span>{{page.route}}</span>
      </div>
    </div>

    <CreatePageDialog
      :isOpen="isDialogPageOpen"
      :type="dialogType"
      :pageToEdit="pageToEdit"
      @onClose="isDialogPageOpen = false"
    />

    <ConfirmDialog 
      v-model="isDeleteDialogOpen"
      title="Remover página"
      :showTitleDivider="false"
      @confirmDone="confirmRemoveStyle(pageToDelete)"
    >
    <template v-if="pageToDelete && pageToDelete.id" slot="content">
      <div class="pt-2 pb-5">
        Deseja remover a página <b>{{pageToDelete.name}}</b>? <br>Essa ação não poderá ser desfeita.
      </div>
    </template>
    </ConfirmDialog>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import { createUsingSchema } from '../../../schemas'
import { PAGE_SCHEMA } from '../../../schemas/pages/schema'
import PopUpMenu from '../../_v2/ui/PopUpMenu.vue'
import ConfirmDialog from '../../_v2/ui/ConfirmDialog.vue'
import CreatePageDialog from './CreatePageDialog.vue'

export default {
  name: 'MenuPages',
  components: { PopUpMenu, ConfirmDialog, CreatePageDialog },
  computed: {
    ...mapGetters(['infos', 'selectedPage']),

    listPages () {
      return this.infos.pages.length > 0 ? this.infos.pages : []
    }
  },

  data: () => ({
    showMenuFromPage: {id: null, index: null},
    hoverStyle: null,
    isDeleteDialogOpen: false,    
    pageToDelete: null, // {index: 0, id: '123x', name: '', route: ''}

    dialogType: 'add', // add or edit
    isDialogPageOpen: false,
    pageToEdit: null
  }),

  methods: {
    getMenuOptions (page, index) {
      const options = [
        {label: 'Editar', action: () => { this.handleEditPage(page, index) }},
        {label: 'Duplicar página', action: () => { this.handleDuplicatePage(page, index) }},
        {label: 'Remover', action: () => { this.handleRemovePage(page, index) }, divider: true},
      ]

      let menu = []

      const cantBeRemoved = ['/']
      const isUnableToRemove = cantBeRemoved.some(i => page.route === i)

      const cantBeEdited = ['/']
      const isUnableToEdit = cantBeEdited.some(i => page.route === i)

      if (isUnableToRemove) menu = options.filter(item => item.label !== 'Remover')
      if (isUnableToEdit) 
        menu = menu.length > 0 ? menu.filter(item => item.label !== 'Editar') : options.filter(item => item.label !== 'Editar')

      return menu.length === 0 ? options : menu
    },

    handleSelectPage (item) {
      this.$store.dispatch('setSelectedPage', item.id)
    },    

    handleAddPage () {
      this.dialogType = 'add'
      this.isDialogPageOpen = true
    },

    onClickMenuOption (id, index) {
      if (this.showMenuFromPage.id === id) {
        this.showMenuFromPage.id = null
        this.showMenuFromPage.index = null
        return
      }
      this.showMenuFromPage.id = id
      this.showMenuFromPage.index = index
    },

    // edit, duplicate and remove    

    handleEditPage (page) {
      this.dialogType = 'edit'
      this.pageToEdit = page
      this.isDialogPageOpen = true
    },

    handleDuplicatePage(page, index) {
      const newDuplicatedPage = createUsingSchema(PAGE_SCHEMA({route: `${page.route}copia`, name: `${page.name} (Cópia)`}))
      this.infos.pages.push(newDuplicatedPage)

      const duplicateSections = this.infos.sections.filter(section => section.pageId === page.id)
        .map(section => ({...section, id: `${newDuplicatedPage.id}-${section.id}`, pageId: newDuplicatedPage.id}))

      this.infos.sections = [...this.infos.sections, ...duplicateSections]
    },

    handleRemovePage(page, index) {
      this.pageToDelete = {index, ...page}
      this.isDeleteDialogOpen = true
    },  

    confirmRemoveStyle(pageToDelete) {
      this.infos.sections = this.infos.sections.filter(info => info.pageId !== pageToDelete.id)
      this.infos.pages = this.infos.pages.filter(page => page.id !== pageToDelete.id)

      const getMainPageId = this.infos.pages.find(page => page.route === '/')
      if (getMainPageId) this.$store.dispatch('setSelectedPage', getMainPageId.id)
    }
  }
}
</script>

<style scoped>
  .pages-item {
    display: flex;
    gap: 10px;
    height: 36px;
    align-items: center;
    font-size: 0.9rem;
    transition: all 0.3s;
    padding-left: 8px;
    border-radius: 4px;
    overflow: hidden;
    white-space: nowrap;
  }

  .pages-item span {
    max-width: 70%;
    overflow: hidden;
    text-overflow: ellipsis;  
  }

  .pages-item:hover {
    background-color: rgba(102, 109, 128, 0.05);
    cursor: pointer;
  }

  .pages-item-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;
    border-radius: 4px;
  }

  .active-page-menu {
    display: flex;
    flex: 1;
    justify-content: end;
    padding-right: 12px;
  }

  .active-page-menu /deep/ .active-page-options {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20px;
    height: 20px;
    padding: 2px;
    transition: all 0.3s;
    border-radius: 4px;
  }

  .active-page-options:hover {
    background-color: #F2F8FF;
  }

  .isPageMenuOpened {
    background-color: #F2F8FF;
  }    
</style>